import { defineTool } from '@/shell/tool';

/** Networks (Flutter `/networks`). */
export default defineTool({
  id: 'networks',
  title: 'Networks',
  summary: 'The networks the schools and their students sit in.',
  section: 'learning-backend',
  order: 40,
  icon: 'polyline',
  owner: '@Drabu',
  permission: 'networks:use',
  routes: () => import('./NetworksPage'),
});
